// extracted by mini-css-extract-plugin
export default {"titleContainer":"TitleSection_titleContainer__zIZLU"};